import React from 'react';
import { Layout } from 'react-admin';
import VeroAppBar from './VeroAppBar';
import Menu from '../layout/Menu';

const VeroLayout = (props) => <Layout 
        {...props} 
        appBar={VeroAppBar} 
        menu={Menu}
    />;

export default VeroLayout;